import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface NavigationGuardDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const NavigationGuardDialog = ({
  isOpen,
  onConfirm,
  onCancel,
}: NavigationGuardDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={isOpen}
      onClose={onCancel}
      aria-labelledby="navigation-guard-title"
      aria-describedby="navigation-guard-description"
    >
      <DialogTitle id="navigation-guard-title">
        {t("navigationGuard.title")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="navigation-guard-description">
          {t("navigationGuard.message")}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button onClick={onCancel} variant="outlined">
          {t("navigationGuard.stay")}
        </Button>
        <Button onClick={onConfirm} variant="contained" autoFocus>
          {t("navigationGuard.leave")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NavigationGuardDialog;
